/**
 * RoleRoute - Restricts a route to specific roles
 *
 * Use when a page should only be accessible by admin or super_admin.
 * Unauthorized users are redirected to the dashboard.
 *
 * @example
 *   <Route path="/users" element={
 *     <RoleRoute allowedRoles={['admin', 'super_admin']}>
 *       <UserManagement />
 *     </RoleRoute>
 *   } />
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const RoleRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default RoleRoute;
